module.exports = "#announcements-list-container{\n    margin-top: 15px;\n}\n\n.pagination /deep/ .ngx-pagination {\n    padding: 0px;\n    zoom: 1.3;\n}"